/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driverremittance_Col_Actions1Inputs */

const vi_driverremittance_col_actions1 = /** @type {(inputs: Driverremittance_Col_Actions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thao tác`)
};

/**

* @param {Driverremittance_Col_Actions1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const driverremittance_col_actions1 = /** @type {((inputs?: Driverremittance_Col_Actions1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driverremittance_Col_Actions1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driverremittance_col_actions1(inputs)
});
export { driverremittance_col_actions1 as "driverRemittance_col_actions" }